import React from "react";

const Footer = () => (
  <footer className="site-footer">
    <div className="container">
      <span className="site-footer-name">QKart</span>
      <p>Your one stop shop for the latest trending items, with India’s fastest delivery to your doorstep.</p>
    </div>
    <style>{`
      .site-footer { background: var(--footer); color: #cfe3d9; padding: 32px 0; text-align: center; font-size: 14px; }
      .site-footer-name { font-weight: 800; font-size: 18px; color: #fff; }
      .site-footer p { margin: 8px auto 0; max-width: 520px; }
    `}</style>
  </footer>
);

export default Footer;
